import {
  EnvSection,
  EnvTopic,
} from '@/domain/impact-env/entities/question.entity';
import {
  EssSection,
  EssTopic,
} from '@/domain/impact-ess/entities/question.entity';
import { language, translate } from '@/ui/i18n';
// ---------

export function getEssTopicName(topic: EssTopic): string {
  return translate(`Ess.Topics.${topic}`);
}
export function getEssSectionName(section: EssSection): string {
  return translate(`Ess.Sections.${section}`);
}

// ---------

export function getEnvTopicName(topic: EnvTopic): string {
  return translate(`Env.Topics.${topic}`);
}

export function getEnvSectionName(section: EnvSection): string {
  return translate(`Env.Sections.${section}`);
}

// ---------

export function formatUnit(maxScore: number): string {
  return `/ ${maxScore.toLocaleString(language)}`;
}
